<template>
  <div class="container-fluid">
    <div class="alert alert-danger alert-margin" role="alert" v-if="isMessage">
      {{ message }}
    </div>
    <div id="title" class="row">
      <div class="col-1">
        <svg id="header" class="bd-placeholder-img mr-2 rounded" width="28" height="28" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 32x32">
        <rect width="100%" height="100%" fill="#00C3E0"></rect>
        </svg>
      </div>
      <div class="col-6">
        <h5>緊急通報履歴</h5>
      </div>
      <div class="col-5">
      </div>  
    </div>
    <div class="row">
      <div class="col-1">
      </div>
      <div class="col-11">期間を指定してください</div>
      <div class="col-12" style="margin-bottom: 10px;"></div>
    </div>
    <div class="row">
      <div class="col-1">
      </div>
      <div class="col-2">
        <div class="form-group">
          <input type="date" class="form-control" v-model="fromDate" min="1900-01-01" max="2100-12-31" required>
        </div>
      </div>  
      <div class="col-1 d-flex align-items-center justify-content-center" style="margin-bottom: 15px;">〜</div>
      <div class="col-2">
        <div class="form-group">
          <input type="date" class="form-control" v-model="toDate" min="1900-01-01" max="2100-12-31" required>
        </div>
      </div>
      <div class="col-2">
          <div class="input-group-append">
              <button class="btn btn-secondary" type="button" v-on:click="search()">
                <img class="search-solid" src="/search-solid.svg">
              </button>
          </div>
      </div>
      <div class="col-4"></div>
    </div>
    <div id="main" class="row">
      <div class="col-1">
      </div>
      <div class="col-8">
        <table class="table table-dark table-sm table-hover">
          <thead>
            <tr>
              <th scope="col" style="width:50px">#</th>
              <th scope="col" style="width:350px">名称</th>
              <th scope="col">通報日時</th>
              <th scope="col" style="width:170px">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(recording, index) in recordings" v-bind:key="recording.fileName">
              <th scope="row">{{ index + 1 }}</th>
              <td>{{ recording.fileName }}</td>
              <td>{{ recording.createdAt }}</td>
              <td>
                <button type="button" class="btn-sm btn-light" v-on:click="download(recording.fileName)">ダウンロードする</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-3">
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import FileSaver from 'file-saver'
import { sessions } from '../../mixin/session'
import { path } from '../../mixin/path'
import { headers } from '../../mixin/headers'

export default {
  name: 'Index',
  mixins: [sessions,path,headers],
  props: ['realms'],
  data () {
    return {
      recordings: [],
      message: '',
      hospitalCode: '',
      fromDate: this.$moment().add(-7, "days").format('YYYY-MM-DD'),
      toDate: this.$moment().format('YYYY-MM-DD')
    }
  },
  mounted() {
    this.hospitalCode = this.$store.getters.hospital.code;
    if(this.hospitalCode != null && this.hospitalCode != ""){
      this.search();
    }
    this.$store.watch(
      (state, getters) => getters.hospital,
      (newValue, oldValue) => {
        if (newValue != oldValue) {
          this.hospitalCode = this.$store.getters.hospital.code
          this.search();
        }
      }
    )
  },
  computed: {
    isMessage: function () {
      return this.message.length > 0
    }
  },
  methods: {
    search() {
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          var privilege = this.$store.getters.user.privilege
          axios
            .post("/api/emergency/recording/list/" + this.hospitalCode, {
                fromDate: this.fromDate,
                toDate: this.toDate,
                privilege: privilege
            },{
              headers: this.headers(accessToken)
            })
            .then(response => {
              this.recordings = response.data.data.recordings;
            })
            .catch(err => {
              this.message = err.message
            })
        }
      }).catch((err) => {
        this.message = err.message
      })
    },
    download(fileName) {
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          var hospitalCode = this.$store.state.hospital.code
          axios.post("/api/emergency/recording/download/", {
              hospitalCode: hospitalCode,
              fileName: fileName
            },{
              headers: this.headers(accessToken),
              responseType: "blob"
          }).then(response => {
            const blob = new Blob([response.data], {
              type: response.data.type
            })
            FileSaver.saveAs(blob, fileName)
          }).catch(err => {
            this.message = err.message
          })
        }
      }).catch((err) => {
        this.message = err.message
      })
    }
  } 
}
</script>

<style scoped>
#header {
  float: right;
} 
#title {
  padding: 10px
}
.alert-margin{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.search-solid{
  cursor: pointer;
  height: 18px;
  width: 18px;
}
</style>